import { FormInputBase } from './form-input-base';

export class FormNumber extends FormInputBase<string> {
  override controlType = 'number';
}
